import { render, staticRenderFns } from "./PropertiesPanel.vue?vue&type=template&id=643c4af9&"
import script from "./PropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./PropertiesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643c4af9')) {
      api.createRecord('643c4af9', component.options)
    } else {
      api.reload('643c4af9', component.options)
    }
    module.hot.accept("./PropertiesPanel.vue?vue&type=template&id=643c4af9&", function () {
      api.rerender('643c4af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/PropertiesPanel.vue"
export default component.exports